module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("Brighten any nursery with this whimsical baby quilt!")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("QUILT TOP MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Block fabrics:")]), _vm._v(" ¾ yard each of 10 prints")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Background fabric:")]), _vm._v(" 2¼ yards white solid")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Animal fabric:")]), _vm._v(" ⅔ yards white solid")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Binding fabric:")]), _vm._v(" ⅝ yard")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Batting:")]), _vm._v(" 67˝ × 81˝")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Appliqué thread, 28 weight:")]), _vm._v(" black or dark coordinating color")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Temporary spray adhesive (See Tip.)")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Tear-away stabilizer:")]), _vm._v(" 12 sheets 15˝ × 24˝ (such as OESD Tear Away)*")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Disappearing-ink fabric marker")])]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('i', [_vm._v("* If you don’t have larger sheets of stabilizer on hand, you can use smaller sheets and overlap them a bit so that they back the entire appliqué area. If you prefer not to use stabilizer, you can heavily starch the background fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("QUILT TOP CUTTING INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("From the block fabrics:")]), _vm._v(" "), _c('p', {
    staticClass: "h2-g"
  }, [_c('i', [_vm._v("From each print:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 1 strip 2½˝ × WOF. Subcut each strip in half to yield 2 pieces 2½˝ × 20˝. Set aside these strips to use for the checkered border.")]), _vm._v(" "), _c('p', {
    staticClass: "h2-g"
  }, [_c('i', [_vm._v("From the remaining yardage:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut a "), _c('i', [_vm._v("total")]), _vm._v(" of 6 squares 13˝ × 13˝ and 3 rectangles 13˝ × 27˝ from the various prints.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Cut a variety of circles 9˝, 7˝, 5˝, and 3˝ in diameter using either the circle patterns (pullout page P1), a compass, circle cutter, or round objects of a similar size. (You’ll need about 60 circles total for the quilt top and back, but you can always go back and cut additional circles as you need them.)")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("From the background solid:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 7 strips 4½˝ × WOF. Piece 2 rectangles 4½˝ × 56½˝ and 2 rectangles 4½˝ × 62½˝ for the outer border.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 11 strips 2½˝ × WOF. Piece 8 of the strips into 2 rectangles 2½˝ × 44½˝ for the inner border and 4 rectangles 2½˝ × 54½˝ for the inner border and sashing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Subcut the remaining 3 strips into 6 rectangles 2½˝ × 12½˝ for sashing and 8 rectangles 2½˝ × 2¼˝ for the checkered borders.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 6 strips 2˝ × WOF. Cut each strip into 2 pieces 2˝ × 20˝ for the checkered borders.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("From the binding fabric:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 7 strips 2¼˝ × WOF.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("WOF = width of fabric")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_c('b', [_vm._v("FINISHED QUILT:")]), _vm._v(" 56½˝ × 70½˝")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Fabrics shown are from the Little Ark collection by Carina Gardiner for Riley Blake Designs and Basics by Riley Blake Designs.")]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Pieced by Amanda Murphy and quilted by Deborah Norris")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Animal Block Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Trace 1 of each of the 4 animals (pullout page P2) onto the right side of the white solid using a water-soluble or heat-removable pen. Be sure to trace lightly—you want it to be easy to cover the lines with machine stitching! Cut out the animals. Set aside the remaining white solid for the animal on the quilt back.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Lightly trace the animal details (the eyes, ears, nose, and the monkey’s hair) onto the right side of the print fabrics for the blocks. Cut out the details.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3.")]), _vm._v(" Spray the back of the animal and the animal detail shapes with temporary spray adhesive, and then position them on the 4 squares 13˝ × 13˝. The bottom raw edge of the animal should align with the bottom raw edge of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("4.")]), _vm._v(" Refer to Tips and Techniques to back the blocks with tear-away stabilizer and, using a blanket stitch and 28-weight thread, secure the edge of the shapes. Outline the animal details by using a triple stitch, going back and forth with machine stitching, or even hand stitching. Remove the stabilizer.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("5.")]), _vm._v(" Trim the blocks to 12½˝ × 12½˝.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Animal block")]), _vm._v(" "), _c('div', {
    staticClass: "tip-b"
  }, [_c('p', {
    staticClass: "tip-h"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("I opted to trace these animals and secure them using temporary spray adhesive because of their large size. For this reason, the animal templates on the insert are not reversed. If you are sewing with dark background fabrics, you can opt to use paper-backed fusible web to trace the animals using a windowing technique (see Appliqué Basics, page 104) instead of using temporary spray adhesive. If you aren’t using the temporary spray adhesive, make sure to trace a mirror-image of the animals included on the pullout if you would like the finished result to be like the original. Also, be careful not to set in any water-soluble pen markings by going over them with your iron! Windowing the fusible will allow you to cut away the background fabric from behind the animal appliqués so that it doesn’t show through.")])]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('i', [_vm._v("Circle Block Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Arrange the circles on the remaining 2 print 13˝ × 13˝ squares and 3 rectangles 13˝ × 27˝. Feel free to have the circles overlap the edges of the fabric for added interest. When you are pleased with the arrangement, spray the back of each circle with temporary spray adhesive and reposition each one on the blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Back the blocks with tear-away stabilizer and, using a blanket stitch and 28-weight thread, secure the edges of the shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3.")]), _vm._v(" Trim the blocks to 12½˝ × 12½˝ and 12½˝ × 26½˝, respectively.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Circle block")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Checkered Border Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Join 1 print strip 2½˝ × 20˝ to 1 background strip 2˝ × 20˝. Repeat to make a total of 12 strip sets. Cut 6 assorted squares 2½˝ × 2½˝ from the remaining print strips and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 5 units 2½˝ wide from each strip set.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Checkered border strip set")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Join 15 of the units from Step 1 to form the checkered border for the side of the quilt top. Join 1 print 2½˝ × 2½˝ square onto 1 end of the border, continuing the checkered pattern. Then join a background 2½˝ × 2¼˝ rectangle onto each end of the border. Repeat to make the other side border.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Side checkered border")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3.")]), _vm._v(" Join 11 of the units from Step 1 together to form the top checkered border. Join 1 print 2½˝ × 2½˝ square on 1 end of the border, continuing the checkered pattern. Then join a background 2½˝ × 2¼˝ rectangle and a print 2½˝ × 2½˝ square onto each end of the border. Repeat to make the bottom checkered border.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Top and bottom checkered borders")]), _vm._v(" "), _c('div', {
    staticClass: "hin-b"
  }, [_c('p', {
    staticClass: "hin-h"
  }, [_vm._v("Hint")]), _vm._v(" "), _c('p', {
    staticClass: "hin"
  }, [_vm._v("If your borders aren’t quite big enough because of all the piecing, use slightly longer background pieces at the ends of each border to make up the difference. No one will ever know!")])]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('i', [_vm._v("Quilt Top Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Following the quilt top assembly diagram (below), join 2 blocks 12½˝ × 12½˝, 1 block 12½˝ × 26½˝, and 2 background rectangles 2½˝ × 12½˝ to form a column. Repeat to make all 3 columns.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Join a background rectangle 2½˝ × 54½˝ between each of the 3 columns to form the center of the quilt top. Then join an additional rectangle on either side for the inner border.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3.")]), _vm._v(" Join a background rectangle 2½˝ × 44½˝ to the top and bottom of the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("4.")]), _vm._v(" Join the longer checkerboard borders to both sides of the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("5.")]), _vm._v(" Join the shorter checkerboard borders to the top and bottom of the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("6.")]), _vm._v(" Join a background rectangle 4½˝ × 62½˝ to the sides of the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("7.")]), _vm._v(" Join a background rectangle 4½˝ × 56½˝ to the top and bottom of the quilt top.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Quilt top assembly")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-head1"
  }, [_c('b', [_vm._v("QUILT BACK")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('b', [_vm._v("66½˝ × 80½˝ unfinished (5˝ larger on all sides than the quilt top)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Bubbles of fun prints float up the back of this quilt!")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("QUILT BACK MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Circles and animal fabric left over from making the quilt top")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Background fabric:")]), _vm._v(" 4¼ yards")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Middle stripe fabric:")]), _vm._v(" 1 yard")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Appliqué thread, 28 weight:")]), _vm._v(" black or dark coordinating color")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Paper-backed fusible web:")]), _vm._v(" ½ yard, 18˝ wide")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Tear-away stabilizer:")]), _vm._v(" ½ yard or 1 sheet*, 15˝ × 24˝")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Tools for personalization")])]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('i', [_vm._v("* If you don’t have larger sheets of stabilizer on hand, you can use smaller sheets and overlap them a bit so that they back the entire appliqué area. If you prefer not to use stabilizer, you can heavily starch the background fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("QUILT BACK CUTTING INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("From the background fabric:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 2 strips 40½˝ × WOF. Subcut into 1 rectangle 40½˝ × 40˝ and 2 rectangles 40½˝ × 13¾˝. Join the smaller rectangles to each side of the large rectangle to yield a pieced rectangle 40½˝ × 66½˝.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 2 strips 27½˝ × WOF. Subcut into 1 rectangle 27½˝ × 40˝ and 2 rectangles 27½˝ × 13¾˝. Join the smaller rectangles to each side of the large rectangle to yield a pieced rectangle 27½˝ × 66½˝.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("From the middle stripe fabric:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut 2 strips 13½˝ × WOF. Subcut into 1 rectangle 13½˝ × 40˝ and 2 rectangles 13½˝ × 13¾˝. Join the smaller rectangles to each side of the large rectangle to yield a pieced rectangle 13½˝ × 66½˝.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('i', [_vm._v("Appliqué")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Trace and appliqué your favorite animal to the middle stripe rectangle, following the instructions in Animal Block Assembly. Be sure to align the bottom raw edge of the animal with the bottom raw edge of the rectangle and position the left edge of the animal 16˝ from the left edge of the rectangle.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Using the quilt back assembly diagram for placement, trace and appliqué the circles following the instructions in Circle Block Assembly to the background. As you’re arranging, remember that anything coming within 5˝ of the raw edges of the sides of the quilt backing will be cut off after the quilting is complete!")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Personalization")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Record the new baby’s name and date of birth next to the animal on the stripe using the technique in Lesley Riley’s TAP Transfer Artist Paper, fabric pens, or machine or hand embroidery. (I used 150-point type.) "), _c('i', [_vm._v("Remember to place text at least ¼˝ from all outer edges so it will not be lost in the seam allowances.")])]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Quilt Back Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Join the larger background rectangle to the top of the stripe.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Join the smaller background rectangle to the bottom of the stripe.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Refer to Finishing Basics for more detailed instructions.")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Layer the backing, batting, and quilt top. Quilt as desired.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Join the 2¼˝ × WOF binding strips into 1 continuous piece for binding. Press, folding the strip in half lengthwise. Sew the binding to the quilt using your preferred method.")]), _vm._v(" "), _c('div', {
    staticClass: "box-b"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('b', [_vm._v("Change It Up")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("This quilt welcomes a new addition to a family, but it’s appropriate as well for a toddler’s birthday (if you happen to miss the birth)! It also lends itself to a wonderful nursery or kid’s room decoration, such as the Baby Safari Wallhangings.")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg23_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Quilt back assembly")]), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_c('p', {
    staticClass: "box-head2"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("BABY SAFARI WALLHANGINGS")]), _vm._v(" "), _c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Finished Wallhanging: 12˝ × 12˝")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Fabrics shown are from the Splendor collection by Lila Tueller for Riley Blake Designs and Basics by Riley Blake Designs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm"
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("Mount the appliquéd blocks onto artist’s canvas for adorable, personalized wall art. Bold background prints are particularly fun!")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("WALLHANGING MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Backgrounds:")]), _vm._v(" ½ yard from each of 4 fabrics (Large, graphic prints work particularly well.)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Animals:")]), _vm._v(" 2/3 yard white solid or white-on-white prints")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Animal details:")]), _vm._v(" Scraps from small-scale coordinating prints")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Appliqué thread, 28 weight:")]), _vm._v(" Black or dark coordinating color")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Temporary spray adhesive")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Tear-away stabilizer:")]), _vm._v(" 2 yards 18˝ wide, or 4 sheets* 15˝ × 24˝")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Batting:")]), _vm._v(" 4 squares 12˝ × 12˝")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("4 artist’s canvases mounted on 12˝ × 12˝ frames")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/bullet1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("Staples and staple gun")])]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_vm._v("* "), _c('i', [_vm._v("If you don’t have larger sheets of stabilizer on hand, you can use smaller sheets and overlap them a bit so that they back the entire appliqué area. If you prefer not to use stabilizer, you can heavily starch the background fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("CUTTING INSTRUCTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("From "), _c('i', [_vm._v("each")]), _vm._v(" background fabric:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut a square 17˝ × 17˝.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Pieced by Amanda Murphy")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Animal Block Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Refer to the Tip to trace the animals (pullout page P2) onto the right side of the white fabric using a water-soluble or heat-removable pen, allowing an extra 2˝ margin at the bottom of each animal to wrap around the artist’s canvas for a clean finish. Trace lightly—you want it to be easy to cover the lines with machine stitching! Cut out the animals.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Lightly trace the animal details (including the eyes, ears, nose, and the monkey’s hair) onto the right side of the small-scale coordinating prints. Cut out the details.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3.")]), _vm._v(" Spray the back of the animals and animal detail shapes with temporary spray adhesive and then position on the blocks. The bottom raw edge of the animal should align with the bottom raw edge of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("4.")]), _vm._v(" Refer to Tips and Techniques to back the blocks with tear-away stabilizer and, using a blanket stitch and 28-weight thread, secure the edge of the shapes. Outline the animal details by using a triple blanket stitch, going back and forth with machine stitching or even hand stitching. Remove the stabilizer.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('i', [_vm._v("Finishing")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("1.")]), _vm._v(" Using temporary spray adhesive, attach a 12˝ × 12˝ square of batting to the front of a canvas-covered frame.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("2.")]), _vm._v(" Place the block right side down on a clean surface. Center the frame, batting side down, on top of the block. Wrap the fabric around to the back of the frame, mitering the corners. Staple the fabric to secure it.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("3.")]), _vm._v(" Repeat the entire process to complete 4 wallhangings.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25_2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1a519d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_chapter1.vue
// module id = 78
// module chunks = 0